import React from "react";

import useWindowDimensions from "../../../../hooks/useWindowDimensions";

import { NavigationButtonTypes } from "../../../../types/button";

import ICONS from "../../../../constants/icons";
import { COLORS } from "../../../../utils/colors";

import MobileImage from "../../../../assets/images/mobile.webp";
import Icon from "../../../icon/Icon";

const storeButtons: NavigationButtonTypes[] = [
  {
    id: 1,
    iconName: ICONS.GOOGLE_PLAY,
    path: "https://play.google.com/store/apps/details?id=com.skillndepth.mobile&pli=1",
  },
  {
    id: 2,
    iconName: ICONS.APP_STORE,
    path: "https://apps.apple.com/rs/app/skill-n-depth/id6578446583",
  },
];

const Stores = () => {
  const { isSmallScreen, isSmallerThanXlScreen } = useWindowDimensions();

  return (
    <div
      className="a-stores row padding-30 text-white justify-center -column-gap15"
      style={{
        background: `linear-gradient(96.19deg, ${COLORS.linearBackgroundLightBlue} 4.89%, ${COLORS.linearBackgroundDarkBlue} 54.96%)`,
      }}
    >
      <div className="_wr">
        <div className="_w">
          <div
            className={`a-stores__textContainer column _12 _l7 text-white ${
              isSmallerThanXlScreen ? "aligned-center -gap20" : ""
            }`}
          >
            <div>
              <p
                className={`-title smallInfoTitle text-white -mb5 ${
                  isSmallScreen ? "text-centered" : ""
                }`}
              >
                Available on Google and Apple Store
              </p>
              <p
                className={`a-stores__text text-white ${
                  isSmallScreen ? "text-centered" : ""
                }`}
              >
                Skill N Dive is available on the Google Play and Apple App
                Store. Get ready to unlock new skills anytime, anywhere!
              </p>
            </div>
          </div>

          <div
            className={`_12 _l5 aligned-center space-between ${
              isSmallScreen ? "column" : ""
            }`}
          >
            <div
              className={`a-stores__storeButtons ${
                isSmallScreen ? "-mt20" : ""
              }`}
            >
              {storeButtons.map(({ id, iconName, path }) => (
                <a href={path} target="_blank" key={id} aria-label={iconName}>
                  <Icon key={id} name={iconName} />
                </a>
              ))}
            </div>
            {!isSmallScreen && <img className="-mobileImg" src={MobileImage} alt="Mobile image"/>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stores;
